import { Card, Col, Descriptions, Popconfirm, Row, Tabs } from 'antd'
import CustomBreadCrumb from '../../../../components/Common/CustomBreadCrumb'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import CreateCargoCont from '../../../../components/Purchasing/Packages/AddPackage/CreateCargoCont'
import PackageForm from '../../../../components/Purchasing/Packages/PackageForm'
import DeliveryStopsCont from '../../../../components/Purchasing/Packages/Stops/DeliveryStopsCont'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CodeIcon from '../../../../elements/CodeIcon'
import CustomSpin from '../../../../elements/CustomSpin'
import LinkHeader from '../../../../elements/LinkHeader'
import Status from '../../../../elements/Status'
import CustomTable from '../../../../elements/Table/CustomTable'
import _, { get } from 'lodash'
import { strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

function AddPackage (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    packageObj,
    remove,
    removing,
    isUpdatable,
    isLocked,
    actions,
    handleActions,
    isConfirmed,
    isNew,
  } = props

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      isRemovable={!isLocked}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )
  const Operations = ({ delivery, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>,
      )
    }
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr]) : []}
      </div>
    )
  }

  console.log({ isConfirmed, locked: packageObj.locked })
  return (
    <CustomSpin spinning={fetching}>
      <LinkHeader
        title={'Package'}
        type={'Delivery Order'}
        link={{
          pathname: `/purchasing/delivery/${_.get(packageObj, 'deliveryOrder._id', '').replace(
            'deliveryOrder/',
            '',
          )}/update`,
        }}
        code={_.get(packageObj, 'deliveryOrder.code', '')}
        name={_.get(packageObj, 'deliveryOrder.title', '')}
        visible={true}
      />
      <Card>
        <Row className={style.pageHeader}>
          <CustomBreadCrumb
            items={[
              { text: 'Purchasing' },
              { text: 'Order' },
              { text: 'Delivery' },
              { text: 'Package', link: '#/purchasing/package/list' },
              { text: isNew ? 'New Package Order' : packageObj.code },
            ]}
          />

          {isNew && <h2 className={style.title}>New Package Order</h2>}
          {!isNew && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <CodeIcon code={strVal(packageObj, 'code')} title={'Delivery Code'}/>
                  <Status value={strVal(packageObj, 'status')}/>
                  <Operations
                    style={{ marginTop: '10px' }}
                    delivery={packageObj}
                    status={strVal(packageObj, 'status')}
                  />
                </h3>
                {isConfirmed && !packageObj.locked && (
                  <CreateCargoCont {...{ selection: [packageObj], selectionRawData: [packageObj] }} />
                )}
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <Descriptions title="Package Details" bordered style={{ marginBottom: 20 }} column={4}>
              <Descriptions.Item label="Purchases Order Line Name" span={4}>
                {get(packageObj, 'purchasesLines.name')}
              </Descriptions.Item>
              <Descriptions.Item label="Delivery Order Line Name" span={4}>
                {get(packageObj, 'deliveryOrderLines.name')}
              </Descriptions.Item>

              <Descriptions.Item label="Type">{get(packageObj, 'purchasesLines.type')}</Descriptions.Item>
              <Descriptions.Item label="Category">{get(packageObj, 'purchasesLines.category')}</Descriptions.Item>
              <Descriptions.Item label="Unit">{get(packageObj, 'unit')}</Descriptions.Item>

              <Descriptions.Item label="Budget Name">{get(packageObj, 'budgetLine.name')}</Descriptions.Item>
            </Descriptions>

            <PackageForm ref={formRef} {...props} />
            <SubmitButton/>
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Stops" key="Stops">
            <DeliveryStopsCont {...{ packageObj }} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Cargos" key="Cargos">
            <CustomTable
              data={[..._.get(packageObj, '_pastCargoes', []), _.get(packageObj, 'currentCargo', [])]}
              defaultPageSize={20}
              isFilterable={true}
              fetching={fetching}
              fetch={fetch}
              columns={[
                { Header: '_id', accessor: '_id' },
                {
                  Header: 'Code',
                  accessor: 'code',
                  Cell: ({ value, original }) => (
                    <Link
                      target={'_blank'}
                      to={`/purchasing/cargo/${_.get(original, '_id', '').replace('cargo/', '')}/update`}>
                      {value}
                    </Link>
                  ),
                },
              ]}
            />
          </Tabs.TabPane>

          <Tabs.TabPane disabled={isNew} tab="Files" key="files">
            <Documents
              key={packageObj._rev}
              editable={true}
              footer={false}
              category={false}
              email={true}
              owner={packageObj}
            />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="History" key="history">
            <History owner={packageObj} key={packageObj._rev} isArray={true}/>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddPackage
